import { render, staticRenderFns } from "./AppClientFilters.vue?vue&type=template&id=cf60a518&"
import script from "./AppClientFilters.vue?vue&type=script&lang=js&"
export * from "./AppClientFilters.vue?vue&type=script&lang=js&"
import style0 from "./AppClientFilters.vue?vue&type=style&index=0&id=cf60a518&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports